export class SourcingMatrixReport {
  id: string;
  projectId: number;
  modelRunId: string;
  scenarioId: string;
  name: string;
  description: string;
  skuGroupId: number;
  outputConfigMetric: string;
  status: string;
  scenarioOutOfSync: boolean;
  selectedSegments: string;
}
